export default {"src":"https://wp-static.smartkarma.com/_next/static/media/event-driven.f56785ce.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};